/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ConversationModalRepliesContainer_comment = {
    readonly id: string;
    readonly replies: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly " $fragmentRefs": FragmentRefs<"ConversationModalCommentContainer_comment">;
            };
        }>;
    };
    readonly replyCount: number;
    readonly " $refType": "ConversationModalRepliesContainer_comment";
};
export type ConversationModalRepliesContainer_comment$data = ConversationModalRepliesContainer_comment;
export type ConversationModalRepliesContainer_comment$key = {
    readonly " $data"?: ConversationModalRepliesContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ConversationModalRepliesContainer_comment">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [
            {
                "defaultValue": 5,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "defaultValue": "CREATED_AT_ASC",
                "kind": "LocalArgument",
                "name": "orderBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": [
                        "replies"
                    ]
                }
            ]
        },
        "name": "ConversationModalRepliesContainer_comment",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": "replies",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "orderBy",
                        "variableName": "orderBy"
                    }
                ],
                "concreteType": "CommentsConnection",
                "kind": "LinkedField",
                "name": "__ConversationModalReplies_replies_connection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__typename",
                                        "storageKey": null
                                    },
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "ConversationModalCommentContainer_comment"
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "replyCount",
                "storageKey": null
            }
        ],
        "type": "Comment",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'cbe30fade3f2445ac80b1ef1eba8c860';
export default node;
